import axios from 'axios';
import { BLCUrl, defaultHeader } from './serviceUtil';
const resourceName = "/customer"
export default class CustomerService {
    save(requestBody) {
        return axios.post(BLCUrl + resourceName, requestBody, { withCredentials: false, headers: defaultHeader }).then(res => res.data);
    }
    update(id, requestBody) {
        return axios.put(BLCUrl + resourceName + "/" + id, requestBody, { withCredentials: false, headers: defaultHeader }).then(res => res.data);
    }
    search(searchData) {
        let searchParams = "?"
        if (searchData?.cateringId) {
            searchParams += "&cateringId=" + searchData.cateringId + "&"
        }
        searchParams += "pageNumber=" + searchData.pageNumber
        if (searchData?.pageSize) {
            searchParams += "&pageSize=" + searchData.pageSize
        }
        return axios.get(BLCUrl + resourceName + searchParams, { withCredentials: false, headers: defaultHeader }).then(res => res.data);
    }
    get(id) {
        return axios.get(BLCUrl + resourceName + "/" + id, { withCredentials: false, headers: defaultHeader }).then(res => res.data);
    }
    getCustomerCateringConfiguration(id) {
        return axios.get(BLCUrl + resourceName + "/configuration/" + id, { withCredentials: false, headers: defaultHeader }).then(res => res.data);
    }
    delete(id) {
        return axios.delete(BLCUrl + resourceName + "/" + id, { withCredentials: false, headers: defaultHeader }).then(res => res.data);
    }
    saveCustomerCateringConfiguration(requestBody) {
        return axios.post(BLCUrl + resourceName + "/configuration", requestBody, { withCredentials: false, headers: defaultHeader }).then(res => res.data);
    }
    generatePublicKey(id) {
        return axios.put(BLCUrl + resourceName + "/generatePublicKey/" + id, {}, { withCredentials: false, headers: defaultHeader }).then(res => res.data);
    }
    getCustomerByDomain(domain) {
        return axios.get(BLCUrl + resourceName + "/domain/" + domain, { withCredentials: false, headers: defaultHeader }).then(res => res.data);
    }
    getCustomerByRegisterKey(registerKey) {
        return axios.get(BLCUrl + resourceName + "/registerKey/" + registerKey, { withCredentials: false, headers: defaultHeader }).then(res => res.data);
    }
    getCustomerPublicMenuLink(id, cateringId) {
        return axios.get(BLCUrl + resourceName + "/generateMenuLink/" + id + "/catering/" + cateringId, { withCredentials: false, headers: defaultHeader }).then(res => res.data);
    }
}
